var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 799.65259 708.46559",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n      fill: #7c7c7c;\n      }\n\n      .cls-2 {\n      fill: #c6c6c6;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "dark",
    className: "cls-1",
    d: "M399.72731,523.93A62.74257,62.74257,0,0,0,337.139,586.51839v121.9472H462.46937V586.51839A62.77367,62.77367,0,0,0,399.72731,523.93Z",
    transform: "translate(0.00146 0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "light",
    className: "cls-2",
    d: "M787.25206,265.58025l-100.1106-75.0445-47.51788-35.67843L459.85515,19.83881a100.8048,100.8048,0,0,0-120.1019,0l-155.625,116.87407-70.27729,52.68336a77.39265,77.39265,0,0,0-12.76371,11.68883L11.895,270.2859A30.986,30.986,0,0,0,6.35927,313.498a30.86263,30.86263,0,0,0,24.45081,11.83948,29.8817,29.8817,0,0,0,18.76127-6.45719l24.29687-18.91644v308.482A100.04853,100.04853,0,0,0,173.825,708.4026H275.62715V586.45686a124.17712,124.17712,0,0,1,248.3541,0V708.4026H625.93718A100.154,100.154,0,0,0,725.894,608.44582V296.4269l24.451,18.29977a30.73108,30.73108,0,1,0,37.14679-48.96646q-.11939-.09055-.23962-.18Z",
    transform: "translate(0.00146 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.1966c5c6.svg";
export { ForwardRef as ReactComponent };